var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module__list_table"},[_c('component-table',{attrs:{"labels":[
            {
                key: 'name',
                title: 'Name',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'description',
                title: 'Description',
                type: 'string'
            },
            {
                key: 'duration',
                title: 'Duration',
                type: 'string'
            },
            {
                key: 'labels',
                title: 'Labels',
                type: 'string'
            },
            {
                key: 'keywords',
                title: 'Keywords',
                type: 'string'
            },
            {
                key: 'status',
                title: 'Status',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'actions',
                title: '',
                type: 'string',
                sortable: false
            }
        ],"items":_vm.items,"component-table-item":_vm.ModuleListTableItem,"sort-queryable":_vm.sortQueryable},on:{"emit-archive-module":_vm.openNotifyArchiveModule,"emit-reactivate-module":_vm.openNotifyReactivateModule,"emit-sort":_vm.handleSort}}),_c('pop-notify',{ref:"notifyarchivemodule",class:'pop__notify--archive',attrs:{"title-text":"Archive module?","cancel-button-text":'Cancel',"submit-button-text":'Archive module',"submit-button-animate-loading":true,"submit-button-danger":true,"prevent-close":true,"content-text":''},on:{"emit-submit":_vm.performArchiveModule}},[(_vm.notifyModuleIncludedInCourses > 0)?[_vm._v("\n            This module is used in "+_vm._s(_vm.notifyModuleIncludedInCourses)+" "+_vm._s(_vm.notifyModuleIncludedInCourses <= 1 ? 'course.' : 'courses.')+" "),_c('br'),_c('br'),_c('component-button',{attrs:{"name":'archive-module-notify-view-usage',"text":true,"to":{ name: 'ebs-course-list', query: { modules: (_vm.notifyModuleId + ";" + _vm.notifyModuleName) }}}},[_vm._v("View usage")]),_c('br'),_c('br')]:_vm._e(),_vm._v("\n        Archived modules: "),_c('br'),_vm._v("\n        - Will no longer be available to add to courses "),_c('br'),_vm._v("\n        - Are not removed from existing courses or reports "),_c('br'),_vm._v("\n        - Can be re-activated at any time "),_c('br'),_c('br'),_vm._v("\n        Do you wish to archive this module?\n    ")],2),_c('pop-notify',{ref:"notifyreactivatemodule",class:'pop__notify--reactivate',attrs:{"title-text":"Re-activate module?","cancel-button-text":'Cancel',"submit-button-text":'Re-activate module',"submit-button-animate-loading":true,"submit-button-icon":true,"submit-button-icon-name":'refresh-cw',"submit-button-icon-align":'right',"prevent-close":true,"content-text":''},on:{"emit-submit":_vm.performReactivateModule}},[_vm._v("\n        Re-activating this module will make it available to add to courses."),_c('br'),_c('br'),_vm._v("\n        Do you wish to re-activate this module?\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }